import { render, staticRenderFns } from "./TamaraInstallmentsModal.vue?vue&type=template&id=689808d8&"
import script from "./TamaraInstallmentsModal.vue?vue&type=script&lang=js&"
export * from "./TamaraInstallmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports